/** Build-time provenance. The ONLY remaining build variable (FE contract §6.1). */
export interface AppEnv {
  deployEnv: string;
}

export const env: AppEnv = {
  deployEnv: import.meta.env.VITE_DEPLOY_ENV?.trim() || 'local',
};
